import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: "",
            component: () => import("./views/layouts/main/Main.vue"),
            children: [
                {
                    path: "",
                    redirect: "/orders",
                },
                {
                    path: "/orders",
                    component: () =>
                        import("./views/pages/Orders/OrderList.vue"),
                },
                {
                    path: "/portal-orders",
                    name: "portal_orders",
                    component: () =>
                        import("./views/pages/PortalOrder/PortalOrderList.vue"),
                },
                {
                    path: "/create-order",
                    name: "create_order",
                    component: () =>
                        import("./views/pages/PortalOrder/PortalOrder.vue"),
                },
                {
                    path: "/portal-order/detail/:orderNumber",
                    name: "portal_order_detail",
                    component: () =>
                        import(
                            "./views/pages/PortalOrder/PortalOrderDetail.vue"
                        ),
                },
                {
                    path: "/documents",
                    name: "documents",
                    component: () =>
                        import("./views/pages/Documents/DocumentList.vue"),
                },
                {
                    path: "/items",
                    name: "items",
                    component: () => import("./views/pages/Items/ItemList.vue"),
                },
                {
                    path: "/quotes",
                    name: "quotes",
                    component: () =>
                        import("./views/pages/Quotes/QuoteList.vue"),
                },
                {
                    path: "/quotes/new",
                    name: "new_quotes",
                    component: () =>
                        import("./views/pages/Quotes/QuoteNew.vue"),
                },
                {
                    path: "/users",
                    name: "users",
                    component: () => import("./views/pages/Users/UserList.vue"),
                },
                {
                    path: "/order_detail/:customer_username/:order_number",
                    name: "order_detail",
                    component: () =>
                        import("./views/pages/Orders/OrderDetail.vue"),
                },
            ],
        },

        /* Full Page Layout */
        {
            path: "",
            component: () => import("./views/layouts/full/FullPage.vue"),
            children: [
                {
                    path: "",
                    redirect: "/auth/login",
                },
                {
                    path: "/auth",
                    component: () => import("./views/pages/Auth.vue"),
                    children: [
                        {
                            path: "/auth/login",
                            name: "login",
                            component: () =>
                                import("./views/pages/Auth/Login.vue"),
                        },
                        {
                            path: "/auth/register",
                            name: "register",
                            component: () =>
                                import("./views/pages/Auth/Register.vue"),
                        },
                        {
                            path: "/auth/register-complete",
                            name: "register-complete",
                            component: () =>
                                import(
                                    "./views/pages/Auth/RegisterComplete.vue"
                                ),
                        },
                        {
                            path: "/auth/forgot-password",
                            name: "forgot-password",
                            component: () =>
                                import("./views/pages/Auth/ForgotPassword.vue"),
                        },
                        {
                            path: "/auth/reset-password",
                            name: "reset-password",
                            component: () =>
                                import("./views/pages/Auth/ResetPassword.vue"),
                        },
                    ],
                },
                {
                    path: "/callback",
                    name: "callback",
                    component: () => import("./views/pages/Callback.vue"),
                },
                {
                    path: "/change_password",
                    name: "change_password",
                    component: () =>
                        import("./views/pages/Users/ChangePassword.vue"),
                },
            ],
        },
        /* Full Page Layout */
    ],
});

router.beforeEach((to, from, next) => {
    if (
        to.path === "/auth/login" ||
        to.path === "/callback" ||
        to.path === "/auth/register" ||
        to.path === "/auth/register-complete" ||
        to.path === "/auth/forgot-password" ||
        to.path === "/auth/reset-password" ||
        to.path.includes("/order_detail") ||
        localStorage.getItem(process.env.MIX_USER_SESSION_VARIABLE_NAME) !==
            null
    ) {
        if (
            to.path === "/auth/login" &&
            to.path === "/callback" &&
            to.path === "/auth/register" &&
            to.path === "/auth/reset-password" &&
            to.path === "/auth/register-complete" &&
            to.path === "/auth/forgot-password" &&
            to.path.includes("/order_detail") &&
            localStorage.getItem(process.env.MIX_USER_SESSION_VARIABLE_NAME) !==
                null
        ) {
            router.push({ path: "/" });
        } else {
            return next();
        }
    } else {
        router.push({ path: "/auth/login", query: { to: to.path } });
    }
});
export default router;
